module.exports = __webpack_public_path__ + "img/646c7df.jpg";